// @flow

import type { Map } from "immutable";
import { sendMessageWithCommsAndAlert } from "./async";
import states from "../states";

import type { Dispatch } from "redux";

export const SET_WITHDRAW_AMOUNT = "SET_WITHDRAW_AMOUNT";
export const SET_WITHDRAW_CONFIRMED = "SET_WITHDRAW_CONFIRMED";
export const SET_WITHDRAW_PAYMENT_METHOD = "SET_WITHDRAW_PAYMENT_METHOD";

export function setWithdrawAmount(amount: number) {
  return { type: SET_WITHDRAW_AMOUNT, amount };
}

export function setWithdrawConfirmed() {
  return { type: SET_WITHDRAW_CONFIRMED };
}

export function setWithdrawPaymentMethod(paymentMethod: string) {
  return { type: SET_WITHDRAW_PAYMENT_METHOD, paymentMethod };
}

// FIXME: session should be an Immutable Record
export function withdrawAch(session: Map<string, any>, amount: number, routingNumber: string, accountNumber: string, history: {}) {
  var userId = session.get("user_id");
  var w9Received = session.get("w_9_received");
  var state = session.getIn(["billing_address", "state"]);

  return (dispatch: Dispatch) => {
    sendMessageWithCommsAndAlert(dispatch, "session:" + userId, "ach_withdraw", {
      amount: amount,
      "routing_number": routingNumber,
      "account_number": accountNumber
    }).then(() => {
      dispatch(setWithdrawConfirmed());
      history.push(confirmationUrl(amount, w9Received, state));
    });
  };
}

function confirmationUrl(amount, w9Received, state) {
  if (w9Received || amount < 600 || getCountry(state) !== "US") {
    return "/withdraw/confirmation";
  } else {
    return "/withdraw/w-9";
  }
}

function getCountry(state) {
  var stateInfo = states.filter(s => s.abbr === state);
  if (stateInfo.length === 0) {
    return undefined;
  }
  return stateInfo[0].country;
}

// FIXME: session should be an Immutable Record
export function withdrawCheck(session: Map<string, any>, amount: number, address: string, city: string, state: string, zipCode: string, history: {}) {
  var userId = session.get("user_id");
  var w9Received = session.get("w_9_received");
  var userState = session.getIn(["billing_address", "state"]);

  return (dispatch: Dispatch) => {
    sendMessageWithCommsAndAlert(dispatch, "session:" + userId, "check_withdraw", {
      amount: amount,
      address: address,
      city: city,
      state: state,
      "zip_code": zipCode
    }).then(() => {
      dispatch(setWithdrawConfirmed());
      history.push(confirmationUrl(amount, w9Received, userState));
    });
  };
}
